module.exports = __webpack_public_path__ + "img/received_packages_blue.17078fc3.svg";